/** Form Market — panel açık tema */

import { PANEL } from "./panelTokens";

export const panelFormMarketIntroSx = {
  mt: 1,
  mb: 3,
  p: { xs: 2, md: 2.5 },
  borderRadius: PANEL.radius.cardSm,
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
  bgcolor: PANEL.blue.soft,
  border: `1px solid ${PANEL.blue.soft25}`,
  boxShadow: PANEL.shadow.card,
};

export const panelFormMarketIntroIconSx = {
  width: 44,
  height: 44,
  borderRadius: PANEL.radius.avatar,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: PANEL.surface,
  color: PANEL.blue.text,
  border: `1px solid ${PANEL.blue.soft25}`,
};

export const panelFormMarketIntroTextSx = {
  color: PANEL.text.body,
  lineHeight: 1.7,
  fontSize: "0.9375rem",
};

export const panelFormMarketSectionTitleSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  letterSpacing: -0.2,
  fontSize: "1.25rem",
  mb: 0.5,
};

export const panelFormMarketSectionDescSx = {
  color: PANEL.text.muted,
  maxWidth: 720,
  lineHeight: 1.6,
  fontSize: "0.9375rem",
};

export const panelFormMarketCardSx = {
  height: "100%",
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  borderRadius: PANEL.radius.card,
  overflow: "hidden",
  boxShadow: PANEL.shadow.card,
  transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: PANEL.shadow.cardHover,
    borderColor: PANEL.accent.softBorder,
  },
};

export const panelFormMarketCardActionSx = {
  height: "100%",
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
};

export const panelFormMarketCardContentSx = {
  p: { xs: 2, md: 2.5 },
  flex: 1,
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

export const panelFormMarketSubcategoryChipSx = {
  bgcolor: PANEL.blue.soft12,
  color: PANEL.blue.text,
  fontWeight: 700,
  border: `1px solid ${PANEL.blue.soft25}`,
  fontSize: "0.75rem",
};

export const panelFormMarketValidatedChipSx = {
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  fontWeight: 700,
  border: `1px solid ${PANEL.accent.softBorder}`,
  fontSize: "0.75rem",
  "& .MuiChip-icon": { color: PANEL.accent.text },
};

export const panelFormMarketClinicalScoreChipSx = {
  bgcolor: PANEL.indigo.soft,
  color: PANEL.indigo.text,
  fontWeight: 700,
  border: `1px solid ${PANEL.indigo.softBorder}`,
  fontSize: "0.75rem",
};

export const panelFormMarketFollowupChipSx = {
  bgcolor: PANEL.blue.soft12,
  color: PANEL.blue.text,
  fontWeight: 700,
  border: `1px solid ${PANEL.blue.soft25}`,
  fontSize: "0.75rem",
};

export const panelFormMarketWarningChipSx = {
  bgcolor: PANEL.warning.soft,
  color: PANEL.warning.text,
  fontWeight: 700,
  border: `1px solid ${PANEL.warning.border}`,
  fontSize: "0.75rem",
};

export const panelFormMarketAutoScoreChipSx = {
  bgcolor: PANEL.fill.muted,
  color: PANEL.text.body,
  fontWeight: 600,
  border: `1px solid ${PANEL.border}`,
  fontSize: "0.7rem",
};


export const panelFormMarketCardTitleSx = {
  color: PANEL.text.primary,
  fontWeight: 800,
  lineHeight: 1.3,
  mb: 1,
  fontSize: "1.05rem",
  letterSpacing: -0.15,
};

export const panelFormMarketCardDescSx = {
  color: PANEL.text.body,
  mb: 2,
  flex: 1,
  lineHeight: 1.6,
  fontSize: "0.875rem",
};

export const panelFormMarketCardMetaSx = {
  color: PANEL.text.muted,
  fontWeight: 600,
  fontSize: "0.75rem",
};

export const panelFormMarketBackButtonSx = {
  mb: 2,
  alignSelf: "flex-start",
  width: "fit-content",
  maxWidth: "100%",
  px: 1.75,
  py: 0.75,
  color: PANEL.accent.text,
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.875rem",
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.accent.soft12,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  boxShadow: PANEL.shadow.card,
  "& .MuiButton-startIcon": { color: PANEL.accent.main },
  "&:hover": {
    bgcolor: PANEL.accent.soft,
    borderColor: PANEL.accent.main,
    color: PANEL.text.primary,
  },
};

export const panelFormMarketFilterWrapSx = {
  mb: 3,
};

export const panelFormMarketFilterTitleSx = {
  fontWeight: 700,
  fontSize: "0.75rem",
  color: PANEL.text.muted,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  mb: 1.1,
};

/** Kapalı: tek satır flex; açık: çok satırlı eşit grid */
export const panelFormMarketFilterGridSx = (expanded = false) =>
  expanded
    ? {
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          sm: "repeat(3, minmax(0, 1fr))",
          md: "repeat(4, minmax(0, 1fr))",
          lg: "repeat(6, minmax(0, 1fr))",
        },
        gap: 1,
      }
    : {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: 1,
        width: "100%",
        "& > *": {
          flex: "1 1 0",
          minWidth: 0,
        },
      };

/**
 * PatientVision hub kartlarındaki renkli vurgu dilimi.
 * @param {{ accent: string, soft: string, softBorder: string, text: string }} tone
 * @param {boolean} selected
 */
export const panelFormMarketFilterCardSx = (tone, selected = false) => ({
  width: "100%",
  minHeight: 52,
  height: "100%",
  px: 1.15,
  py: 1,
  borderRadius: "12px",
  border: `1px solid ${selected ? tone.softBorder : PANEL.border}`,
  bgcolor: selected ? tone.soft : PANEL.surface,
  color: PANEL.text.primary,
  boxShadow: selected ? `0 6px 16px ${tone.glow}` : PANEL.shadow.card,
  cursor: "pointer",
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  gap: 1,
  transition: "transform 0.18s ease, border-color 0.15s ease, box-shadow 0.18s ease, background-color 0.15s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    borderColor: tone.softBorder,
    bgcolor: tone.soft,
    boxShadow: `0 8px 18px ${tone.glow}`,
  },
  "&.Mui-disabled": {
    opacity: 0.4,
    cursor: "default",
    transform: "none",
    boxShadow: "none",
  },
});

export const panelFormMarketFilterCardDotSx = (tone) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  flexShrink: 0,
  bgcolor: tone.accent,
  boxShadow: `0 0 0 3px ${tone.glow}`,
});

export const panelFormMarketFilterCardLabelSx = {
  fontWeight: 700,
  fontSize: "0.78rem",
  lineHeight: 1.25,
  letterSpacing: "-0.01em",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

/** @param {{ accent: string, soft: string, text: string }} tone */
export const panelFormMarketFilterCardCountSx = (tone, selected = false) => ({
  flexShrink: 0,
  minWidth: 26,
  height: 24,
  px: 0.75,
  borderRadius: "8px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "0.75rem",
  fontWeight: 800,
  fontVariantNumeric: "tabular-nums",
  bgcolor: selected ? PANEL.surface : tone.soft,
  color: tone.text,
  border: `1px solid ${tone.softBorder}`,
});

/** Daha fazla branş — dikkat çeken genişlet / daralt kontrolü */
export const panelFormMarketFilterExpandSx = (expanded = false) => ({
  mt: 1.25,
  width: "100%",
  minHeight: 44,
  px: 1.5,
  py: 1,
  borderRadius: "12px",
  border: `1.5px dashed ${expanded ? PANEL.accent.softBorder : PANEL.blue.soft25}`,
  bgcolor: expanded ? PANEL.accent.soft12 : PANEL.blue.soft12,
  color: expanded ? PANEL.accent.text : PANEL.blue.text,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  cursor: "pointer",
  transition: "border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease",
  boxShadow: expanded ? "none" : `0 0 0 0 ${PANEL.blue.soft25}`,
  animation: expanded ? "none" : "formMarketFilterPulse 2.2s ease-out infinite",
  "@keyframes formMarketFilterPulse": {
    "0%, 100%": { boxShadow: `0 0 0 0 rgba(59, 130, 246, 0.35)` },
    "50%": { boxShadow: `0 0 0 8px rgba(59, 130, 246, 0)` },
  },
  "&:hover": {
    bgcolor: expanded ? PANEL.accent.soft18 : PANEL.blue.soft30,
    borderColor: expanded ? PANEL.accent.main : PANEL.blue.main,
    transform: "translateY(-1px)",
    animation: "none",
  },
});

export const panelFormMarketFilterExpandLabelSx = {
  fontWeight: 800,
  fontSize: "0.82rem",
  letterSpacing: "-0.01em",
};

export const panelFormMarketFilterExpandHintSx = {
  fontWeight: 600,
  fontSize: "0.72rem",
  opacity: 0.85,
};

export const panelFormMarketFileBannerSx = {
  mb: 2.5,
  p: { xs: 1.75, md: 2 },
  borderRadius: PANEL.radius.cardSm,
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
  bgcolor: PANEL.accent.soft12,
  border: `1px solid ${PANEL.accent.softBorder}`,
};
